import axios from "@/libs/api.request";

export const login = ({ userName, password }) => {
  const data = {
    account: userName,
    password: password,
    role: "Staff"
  };
  return axios.request({
    url: "/user/login",
    data,
    method: "post"
  });
};

export const getUserInfo = () => {
  return axios.request({
    url: "/user/info",
    method: "get"
  });
};

export const logout = () => {
  return axios.request({
    url: "/user/logout",
    method: "get"
  });
};

// export const getUnreadCount = () => {
//   return axios.request({
//     url: 'message/count',
//     method: 'get'
//   })
// }

export const getMessage = () => {
  return axios.request({
    url: "message/init",
    method: "get"
  });
};

export const getContentByMsgId = msg_id => {
  return axios.request({
    url: "message/content",
    method: "get",
    params: {
      msg_id
    }
  });
};

export const hasRead = msg_id => {
  return axios.request({
    url: "message/has_read",
    method: "post",
    data: {
      msg_id
    }
  });
};

export const removeReaded = msg_id => {
  return axios.request({
    url: "message/remove_readed",
    method: "post",
    data: {
      msg_id
    }
  });
};

export const restoreTrash = msg_id => {
  return axios.request({
    url: "message/restore",
    method: "post",
    data: {
      msg_id
    }
  });
};

export const statistics = () => {
  return axios.request({
    url: "/statistics/getSignedAmount"
  });
};

export const monthShipped = params => {
  return axios.request({
    url: "statistics/monthShipped",
    params
  });
};

export const weeksShipped = () => {
  return axios.request({
    url: "statistics/weeksShipped"
  });
};

export const getShipped = params => {
  return axios.request({
    url: "/statistics/getShipmentNumber",
    methods: "get",
    params
  });
};

export const getMenu = () => {
  return axios.request({
    url: "/authority/menu/select",
    method: "get"
  });
};

// 获取头程时效统计
export const getHeadTime = params => {
  return axios.request({
    url: "/statistics/getHeadwayAging",
    method: "get",
    params
  });
};

// 获取头程时效统计
export const getBlindSLA = params => {
  return axios.request({
    url: "/statistics/getBlindSLA",
    method: "get",
    params
  });
};

// 获取用户推送消息
export const getUserMsg = params => {
  return axios.request({
    url: "/finance/feedback/remind",
    method: "get",
    params
  });
};

// 推送最新消息
export const pushMsg = params => {
  return axios.request({
    url: "/finance/feedback/elastic",
    method: "get",
    params
  });
};

// 推送最新消息
export const pushClaimMsg = params => {
  return axios.request({
    url: "/finance/claim/elastic",
    method: "get",
    params
  });
};

// // 超时未派统计
// export const getSignedAmount = params => {
//   return axios.request({
//     url: "/statistics/getSignedAmount",
//     method: "get",
//     params
//   });
// };

// 获取消息列表
export const getMessageList = params => {
  return axios.request({
    url: "/reminder",
    method: "get",
    params
  });
};

// 获取消息详情
export const getMessageDetail = id => {
  return axios.request({
    url: "/reminder/" + id,
    method: "get"
  });
};

// 更新消息状态
export const updateMessageStatus = id => {
  return axios.request({
    url: "/reminder/" + id,
    method: "put"
  });
};


export const batchRead = data => {
  return axios.request({
    url: "/reminder/batchRead",
    method: "post",
    data
  });
};